// /app/frontend/src/components/frugal-v2/components/scheduled/ScheduledChargeForm.jsx
// Form for adding/editing scheduled charges (120 lines)

import React from 'react';
import { X, Loader2 } from 'lucide-react';
import { CATEGORIES } from './scheduledTranslations';

export default function ScheduledChargeForm({ 
  formData, 
  setFormData, 
  onSubmit, 
  onCancel, 
  saving, 
  isEditing, 
  t 
}) {
  const handleChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  return (
    <div className="bg-slate-800/50 rounded-xl p-4 border border-white/10">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-white font-medium">{isEditing ? t.edit : t.add}</h3>
        <button onClick={onCancel} className="p-1 hover:bg-white/10 rounded">
          <X className="w-4 h-4 text-slate-400" />
        </button>
      </div>
      
      <form onSubmit={onSubmit} className="space-y-4">
        {/* Name */}
        <div>
          <label className="block text-sm text-slate-400 mb-1">{t.name}</label>
          <input
            type="text"
            value={formData.name}
            onChange={(e) => handleChange('name', e.target.value)}
            className="w-full bg-slate-700/50 text-white px-3 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-emerald-500"
            required
          />
        </div>
        
        {/* Amount */}
        <div>
          <label className="block text-sm text-slate-400 mb-1">{t.amount}</label>
          <input
            type="number"
            step="0.01"
            value={formData.amount}
            onChange={(e) => handleChange('amount', e.target.value)}
            className="w-full bg-slate-700/50 text-white px-3 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-emerald-500"
            required
          />
        </div>
        
        {/* Category */}
        <div>
          <label className="block text-sm text-slate-400 mb-1">{t.category}</label>
          <select
            value={formData.category}
            onChange={(e) => handleChange('category', e.target.value)}
            className="w-full bg-slate-700/50 text-white px-3 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-emerald-500"
          >
            {CATEGORIES.map(cat => (
              <option key={cat} value={cat}>{cat}</option>
            ))}
          </select>
        </div>
        
        {/* Month & Day */}
        <div className="grid grid-cols-2 gap-3">
          <div>
            <label className="block text-sm text-slate-400 mb-1">{t.month}</label>
            <select
              value={formData.month}
              onChange={(e) => handleChange('month', parseInt(e.target.value))}
              className="w-full bg-slate-700/50 text-white px-3 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-emerald-500"
            >
              {t.months.map((m, idx) => (
                <option key={idx} value={idx + 1}>{m}</option>
              ))}
            </select>
          </div>
          <div>
            <label className="block text-sm text-slate-400 mb-1">{t.day}</label>
            <input
              type="number"
              min="1"
              max="31"
              value={formData.day}
              onChange={(e) => handleChange('day', parseInt(e.target.value))}
              className="w-full bg-slate-700/50 text-white px-3 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-emerald-500"
            />
          </div>
        </div>
        
        {/* Year */}
        <div>
          <label className="block text-sm text-slate-400 mb-1">
            {t.year} <span className="text-xs text-slate-500">({t.yearHint})</span>
          </label>
          <input
            type="number"
            min="2024"
            max="2030"
            value={formData.year}
            onChange={(e) => handleChange('year', e.target.value)}
            className="w-full bg-slate-700/50 text-white px-3 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-emerald-500"
            placeholder="2025"
          />
        </div>
        
        {/* Buttons */}
        <div className="flex gap-2 pt-2">
          <button
            type="button"
            onClick={onCancel}
            className="flex-1 py-2 bg-slate-700 hover:bg-slate-600 text-white rounded-lg"
          >
            {t.cancel}
          </button>
          <button
            type="submit"
            disabled={saving}
            className="flex-1 py-2 bg-emerald-600 hover:bg-emerald-700 disabled:opacity-50 text-white rounded-lg flex items-center justify-center gap-2"
          >
            {saving && <Loader2 className="w-4 h-4 animate-spin" />}
            {saving ? t.saving : t.save}
          </button>
        </div>
      </form>
    </div>
  );
}
